import React from 'react';
import { motion } from 'framer-motion';
import { HerbSprig, LeafCluster } from './HealingIcons';
export const Section = ({
  children,
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6
}} className={`${`py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full bg-transparent ${className}`} pt-[4px]`} data-id="element-374" data-mp="136kqpd95b2ta">
    {children}
  </motion.section>;
export const LeafDivider = ({
  className = ''
}: {
  className?: string;
}) => <div className={`flex items-center justify-center gap-3 my-8 ${className}`} aria-hidden="true" data-id="element-375" data-mp="pfflzwqx7kc3">
    <span className="h-px w-16 md:w-28 bg-gradient-to-r from-transparent to-brand-greenLight/60" data-id="element-376" data-mp="1vu85gbnqiz80" />
    <LeafCluster className="w-4 h-4 opacity-70" color="#6FA524" data-id="element-377" data-mp="20s9qv38mvamn" />
    <HerbSprig className="w-5 h-5 opacity-80" color="#2F6B34" data-id="element-378" data-mp="39k9ce37d4vm3" />
    <LeafCluster className="w-4 h-4 opacity-70" color="#C9A961" style={{
    transform: 'scaleX(-1)'
  }} data-id="element-379" data-mp="39hn2vy0ww618" />
    <span className="h-px w-16 md:w-28 bg-gradient-to-l from-transparent to-brand-greenLight/60" data-id="element-380" data-mp="30ijj0rtx7mlo" />
  </div>;
export const CTAButton = ({
  children,
  href,
  className = '',
  fullWidth = false,
  variant = 'purple',
  onClick
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
  onClick?: () => void;
}) => {
  const bgClass = variant === 'purple' ? 'purple-gradient-bg' : 'gold-gradient-bg';
  const shadowClass = variant === 'purple' ? 'shadow-[0_0_20px_rgba(47,107,52,0.35)] hover:shadow-[0_0_30px_rgba(111,165,36,0.55)]' : 'shadow-[0_0_20px_rgba(201,169,97,0.3)] hover:shadow-[0_0_30px_rgba(201,169,97,0.5)]';
  const classes = `inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white ${bgClass} rounded-full ${shadowClass} transition-shadow duration-300 cursor-pointer ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} onClick={onClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-381" data-mp="1j9shetp33t8w">
        {children}
      </motion.a>;
  }
  return <motion.a href="#pricing" onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} data-id="element-382" data-mp="2byybsmhlgrbs">
      {children}
    </motion.a>;
};